import { Gender, MerchantServiceDto, MerchantUserType } from "@/models/club";
import { ImageType } from "react-images-uploading";

export type CreateUserPayload = {
  FirstName?: string;
  LastName?: string;
  JobTitle?: string;
  MobileNumber?: string;
  MerchantUserType?: MerchantUserType;
  Gender?: Gender;
  /** @format date-time */
  BirthDate?: string;
  CalendarColor?: string;
  ServiceIds?: number[];
  /** @format binary */
  file?: File;
  File?: File;
  "UserInfo.UserId"?: number;
  "UserInfo.MobileNumber"?: string;
  ShowOnWebsite?: boolean;
  /** @format int32 */
  MerchantUserId?: number;
  MarkupPercentage?: number;
};

export type CreateUserPayloadForm = CreateUserPayload & {
  profileImage?: ImageType[];
  services: MerchantServiceDto[];
  day?: string;
  month?: string;
  year?: string;
  genderForm?: string;
  merchantUserTypeForm?: string;
  markupPercentageFrom?: string;
};

// Map string values to numeric enum values
export const merchantUserTypeMap: Record<string, number> = {
  Admin: 0, // ادمین
  Manager: 1, // مدیر سالن
  Barber: 2, // آرایشگر
};
